import { ReactElement } from 'react';
import { OverlayContent } from './overlay-content';

export const GUIOverlay = (): GUIOverlay => {
  let instance: GUIOverlay | null = (window as any).gui_overlay || null;

  if (instance) {
    return instance;
  }

  const gameOverlay = new OverlayContent();

  const openOverlay = (content: ReactElement) => {
    return gameOverlay.openOverlay(content);
  };

  instance = {
    openOverlay,
  };

  (window as any).gui_overlay = instance;

  return instance;
};

export type GUIOverlay = {
  openOverlay: (content: ReactElement) => () => void;
};
